import React, { useState } from "react";
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants, FAQConstants } from "utils/constants";
//#endregion
//#region components
import SupportHelperImg from "images/support-helper.png";
import { Button, ClickAwayListener, Divider, Grid, Grow } from "@mui/material";
import { Icon } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const FAQHelper: React.FC = (props) => {
  const [showFAQ, setShowFAQ] = useState<boolean>(false);

  const handleClickAway = () => {
    setShowFAQ(false);
  };

  const handleClick = () => {
    setShowFAQ(true);
  };

  const onImageLoaded = () => {
    setShowFAQ(true);
  };

  const onFAQButtonClick = () => {
    window.open(FAQConstants.FAQUrl, "_blank");
  };

  const faqMessageList = [
    {
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.FAQHelpItem1Title),
      text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.FAQHelpItem1Text),
      url: `${FAQConstants.FAQUrl}/${FAQConstants.FAQPageUrl}/${FAQConstants.Article1Url}`,
    },
    {
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.FAQHelpItem2Title),
      text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.FAQHelpItem2Text),
      url: `${FAQConstants.FAQUrl}/${FAQConstants.FAQPageUrl}/${FAQConstants.Article2Url}`,
    },
    {
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.FAQHelpItem3Title),
      text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.FAQHelpItem3Text),
      url: `${FAQConstants.FAQUrl}/${FAQConstants.FAQPageUrl}/${FAQConstants.Article3Url}`,
    },
  ];

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div>
        <img src={SupportHelperImg} onClick={handleClick} className={cssExports.faqHelper} onLoad={onImageLoaded} />
        <Grow timeout={500} in={showFAQ} mountOnEnter unmountOnExit>
          <Grid container className={cssExports.faqMessageBubbleContainer}>
            <Grid container className={cssExports.faqMessageBubble}>
              <Grid item container className={cssExports.faqMessageBubbleTitle}>
                {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.FAQHelpTitle)}
              </Grid>

              <Grid container className={cssExports.faqMessageContainer}>
                {faqMessageList.map((faq, index) => (
                  <Grid
                    key={index}
                    item
                    container
                    className={cssExports.faqMessageBubbleItem}
                    component={"a"}
                    href={faq.url}
                    target="_blank"
                  >
                    <Grid item className={cssExports.faqMessageBubbleItemIcon}>
                      <Icon icon={IconDefinitionConstants.WCommentDots} />
                    </Grid>
                    <Grid item xs container>
                      <Grid container className={cssExports.faqMessageBubbleItemTitle}>
                        {faq.title}
                      </Grid>
                      <Grid container className={cssExports.faqMessageBubbleItemText}>
                        <div>{faq.text}</div>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            <Grid container>
              <Divider className={cssExports.dividerBlue} />
            </Grid>
            <Grid item container className={cssExports.faqButtonContainer}>
              <Grid item xs className={cssExports.faqMessageText}>
                {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SupportIssue.FAQFindMore)}
              </Grid>
              <Grid item>
                <Button className={clsx(cssExports.button, cssExports.btnXSmall)} onClick={onFAQButtonClick}>
                  {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Faq)}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grow>
      </div>
    </ClickAwayListener>
  );
};

export default FAQHelper;
